import React, { useContext } from "react";
import { AuthContext } from "../../context/auth/AuthContext";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { UsePlant } from "../../api/plant/Plant.api";

const DetailPlantContainer = ({ id, children }) => {
  const { token } = useContext(AuthContext);
  const { content, loading, error } = UsePlant(token, id);

  return (
    <>
      {error ? <Error message={error.message} /> : null}
      {loading ? <Loading /> : null}
      {content ? children({ content }) : null}
    </>
  );
};

export default DetailPlantContainer;
